import React from 'react';
import styled from 'styled-components';
import { Button } from '@solvhealth/jigsaw-v1';
import { colors } from '../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../constants/text';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import { PROFILES_TOUCH_ADD_INSURANCE } from '../../../../../../core/analytics/events';
import history from '../../../../../../core/history';

const Root = styled.div.withConfig({ componentId: 'sc-156h3dt-0' })`
  text-align: center;
  margin-top: 36px;
  padding: 0 24px;
`;

const Title = styled.h2.withConfig({ componentId: 'sc-156h3dt-1' })`
  color: ${colors.squid};
  font-size: ${fontSize.large};
  font-family: ${fontFamily.bold};
`;

const Copy = styled.p.withConfig({ componentId: 'sc-156h3dt-2' })`
  font-family: ${fontFamily.book};
  color: ${colors.lightText};
  font-size: ${fontSize.mediumSmall};
  padding: 0 20px;
`;

const StyledImage = styled.div.withConfig({ componentId: 'sc-156h3dt-3' })`
  text-align: center;
  padding: 12px 36px;

  & > img {
    display: inline-block;
    height: 122px;
  }
`;

type Props = {
  userProfileId?: string;
};

const EmptyState = (props: Props) => {
  const { userProfileId } = props;
  const handleAddInsuranceButtonClick = (event: any) => {
    event.stopPropagation();
    const trackingProperties = { userProfileId, insuranceType: 'medical' };
    analyticsTrackEvent(PROFILES_TOUCH_ADD_INSURANCE, trackingProperties);
    history.push(`/add-insurance/up?p=${userProfileId}`);
  };

  return (
    <Root>
      <StyledImage>
        <img alt="Health Insurance Card" src="/images/account/insurance-icon.svg" />
      </StyledImage>

      <Title>Track deductible spending and unlock hidden benefits</Title>

      <Copy>Snap a photo of your card to view your benefits and track your deductible.</Copy>

      <Button
        fullWidth
        maxWidth="366px"
        onClick={handleAddInsuranceButtonClick}
        sx={{ margin: '48px auto 0' }}
      >
        Add Insurance
      </Button>
    </Root>
  );
};

export default EmptyState;
